
















import tabAchievements from "./tabAchievements/index.vue";
import tabStore from "./tabStore/index.vue";
import eventBus from "@/utils/bus";
import { PageModule } from "@/store/module/page";
import { Component, Vue } from "vue-property-decorator";
import tabStoreDetail from "./storeDetail/index.vue";
@Component({
  components: {
    tabAchievements,
    tabStore,
    tabStoreDetail,
  },
})
export default class extends Vue {
  activeName: string = "store";
  created() {
    eventBus.$on("quickly-create-salary-settlement", () => {
      this.activeName = "store";
    });
    const cache = PageModule.pageInfo.salary;
    if (cache.tab) {
      this.activeName = cache.tab;
    }
  }
  beforeDestroy() {
    eventBus.$off("quickly-create-salary-settlement");
  }
  handleTabChange(v: any) {
    PageModule.SET_PAGE_INFO({
      name: "salary",
      key: "tab",
      value: v.name,
    });
  }
}
